import { c as _c } from "react/compiler-runtime";
import { stegaClean } from "next-sanity";
import { ColorBlock } from "@repo/ui/color-block";
import { HoldingShape } from "@repo/ui/holding-shape";
import { cn } from "@repo/ui/utils";
import { ImageWrapper } from "@/components/common/image/image.component";
import type { BannerColorBlockProps } from "./banner-color-block.types";
export function BannerColorBlock(t0) {
  const $ = _c(18);
  const {
    image,
    maskedImage: t1,
    colour,
    className
  } = t0;
  const maskedImage = t1 === undefined ? "none" : t1;
  let t2;
  if ($[0] !== maskedImage) {
    t2 = stegaClean(maskedImage);
    $[0] = maskedImage;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const cleanMaskedImage = t2;
  const hasMask = cleanMaskedImage !== "none";
  let t3;
  if ($[2] !== colour) {
    t3 = stegaClean(colour) ?? "bright-blue";
    $[2] = colour;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const resolvedColour = t3;
  let t4;
  if ($[4] !== className) {
    t4 = cn("aspect-square", className);
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== cleanMaskedImage || $[7] !== hasMask || $[8] !== image) {
    t5 = image && hasMask && <div className="flex h-full w-full items-center justify-center p-[13%]"><HoldingShape variant={cleanMaskedImage} className="w-full"><ImageWrapper visual={image} className="h-full w-full" imgClassName="object-cover" /></HoldingShape></div>;
    $[6] = cleanMaskedImage;
    $[7] = hasMask;
    $[8] = image;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== hasMask || $[11] !== image) {
    t6 = image && !hasMask && <div className="h-full w-full overflow-hidden"><ImageWrapper visual={image} className="h-full w-full" imgClassName="object-cover" /></div>;
    $[10] = hasMask;
    $[11] = image;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== resolvedColour || $[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <ColorBlock variant="square" color={resolvedColour} className={t4} data-testid="banner-color-block">{t5}{t6}</ColorBlock>;
    $[13] = resolvedColour;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}